import { generateKeys } from '../utils';
import { companies } from './companies';
export const faqCategories = generateKeys({
    categoryA: {
        value: 'categoryA',
        label: 'Category A',
    },
});
export const faqMessages = generateKeys({
    positionNegativeQuestion: {
        value: 'positionNegativeQuestion',
        label: 'Did you now why your position opens in negative?',
    },
    positionNegativeAnswer: {
        value: 'positionNegativeAnswer',
        label: 'Did you now why your position opens in negative?',
    },
    leverageChangeQuestion: {
        value: 'leverageChangeQuestion',
        label: 'Did you know you can change leverage?',
    },
    leverageChangeAnswer: {
        value: 'leverageChangeAnswer',
        label: 'Pass the approp test and change your leverage.',
    },
});
export const faq = generateKeys({
    positionNegative: {
        question: faqMessages.positionNegativeQuestion,
        answer: faqMessages.positionNegativeAnswer,
        category: faqCategories.categoryA,
    },
    leverageChange: {
        question: faqMessages.leverageChangeQuestion,
        answer: faqMessages.leverageChangeAnswer,
        category: faqCategories.categoryA,
        company: [companies.bdSwiss.value],
    },
});
